import { render, staticRenderFns } from "./BaseAddress.vue?vue&type=template&id=22e1ee66&"
import script from "./BaseAddress.vue?vue&type=script&lang=ts&"
export * from "./BaseAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports